import api from '../index'

export interface SelectOptionItem {
  value: number | string
  label: string
  disabled?: boolean
}

export interface TreeSelectOptionItem extends SelectOptionItem {
  parent_id?: number
  level?: number
  source_type?: string
  children?: TreeSelectOptionItem[]
}

export interface GoodsCategoryItem {
  id: number
  third_category_id: string
  parent_id: number
  name: string
  level: number
  is_top: number
  source_type: string
  status: number
  sort: number
  created_at: string | null
  updated_at: string | null
  children_count?: number
  children?: GoodsCategoryItem[]
  has_children?: boolean
}

export interface GoodsCategoryParentOption {
  value: number
  label: string
  parent_id: number
  level: number
  source_type: string
  disabled?: boolean
  children?: GoodsCategoryParentOption[]
}

export interface GoodsCategorySyncPayload {
  status: string
  message: string
  sync_mode: string
  provider: string
  executed_at: string
}

export interface GoodsCategoryStatsPayload {
  filtered_total: number
  top_count: number
  enabled_count: number
  disabled_count: number
}

export interface GoodsAttributeGroupItem {
  id: number
  name: string
  status: number
  sort: number
  category_bind_mode: string
  category_count?: number
  option_library_count?: number
  remark: string
  created_at: string | null
  updated_at: string | null
}

export interface GoodsAttributeGroupCategoryRelation {
  id: number
  name: string
  third_category_id: string
  status: number
}

export interface GoodsAttributeGroupOptionRelation {
  id: number
  name: string
  input_type: string
  option_count: number
  status: number
  required: number
}

export interface GoodsAttributeGroupDetailItem extends GoodsAttributeGroupItem {
  category_ids: number[]
  option_library_ids: number[]
  categories: GoodsAttributeGroupCategoryRelation[]
  option_libraries: GoodsAttributeGroupOptionRelation[]
}

export interface GoodsOptionLibraryItem {
  id: number
  name: string
  input_type: string
  options_json: any[] | null
  status: number
  created_at: string | null
  updated_at: string | null
}

export interface GoodsCategoryGroupRelationItem {
  id: number
  category_id: number
  category_name: string
  group_id: number
  group_name: string
  sort: number
  created_at: string | null
  updated_at: string | null
}

export interface GoodsAttributeGroupOptionItem {
  id: number
  group_id: number
  group_name: string
  option_library_id: number
  option_library_name: string
  sort: number
  required: number
  created_at: string | null
  updated_at: string | null
}

export interface GoodsServiceFeeRuleItem {
  id: number
  category_id: number
  category_name: string
  group_id: number
  group_name: string
  fee_rate: number
  status: number
  effective_at: string | null
  expired_at: string | null
  created_at: string | null
  updated_at: string | null
}

export interface GoodsItemMediaAttachment {
  id: number
  url: string
  origin_name: string
  mime_type: string
  is_image: boolean
  is_video: boolean
}

export interface GoodsItemMediaRecord {
  id: number
  goods_id: number
  attachment_id: number
  media_type: string
  sort: number
  attachment?: GoodsItemMediaAttachment | null
}

export interface GoodsItemAdminRecord {
  id: number
  goods_no: string
  seller_user_id: number
  seller_merchant_id: number
  category_id: number
  category_name: string
  config_group_id: number
  title: string
  content: string | null
  price: string
  original_price: string
  price_type: string
  condition_text: string
  shipping_type: string
  pickup_enabled: number
  location_name: string
  location_address: string
  province_name: string
  city_name: string
  area_name: string
  cover_attachment_id: number | null
  video_attachment_id: number | null
  attributes_json: Record<string, any>[] | Record<string, any> | null
  ai_category_snapshot: Record<string, any> | null
  media_count: number
  browse_count: number
  want_count: number
  like_count: number
  message_count: number
  content_status: string
  content_status_text?: string
  display_status: string
  display_status_text?: string
  audit_remark?: string | null
  audited_at?: string | null
  published_at: string | null
  last_on_shelf_at: string | null
  sold_at: string | null
  created_at: string | null
  updated_at: string | null
  related_order_no?: string
  related_order_status?: string
  related_order_status_text?: string
  related_payment_status?: string
  related_payment_status_text?: string
  related_refund_status?: string
  related_refund_status_text?: string
  related_pay_price?: string
  related_discount_amount?: string
  related_paid_at?: string | null
  related_shipped_at?: string | null
  related_received_at?: string | null
  related_completed_at?: string | null
  related_buyer_user_id?: number
  related_buyer_name?: string
  related_buyer_phone?: string
  latest_payment_order_no?: string
  latest_payment_amount?: string
  latest_payment_status?: string
  latest_payment_status_text?: string
  latest_refund_order_no?: string
  latest_refund_amount?: string
  latest_refund_status?: string
  latest_refund_status_text?: string
  content_audit_summary?: Record<string, any> | null
  cover?: GoodsItemMediaAttachment | null
  video?: GoodsItemMediaAttachment | null
  media_list?: GoodsItemMediaRecord[]
}

export interface GoodsItemMessageRecord {
  id: number
  goods_id: number
  user_id: number
  seller_user_id: number
  reply_message_id: number
  message_content: string
  status: string
  status_text?: string
  audit_status: number
  audit_status_text?: string
  audit_remark?: string | null
  audit_at?: string | null
  footprint_hidden: number
  created_at: string | null
  updated_at: string | null
  goods_title?: string
  goods_status?: string
  user_name?: string
  user_avatar?: string
  seller_name?: string
  reply_preview?: string
  reply_type?: string
  reply_type_text?: string
}

export interface GoodsItemMessageDetail extends GoodsItemMessageRecord {
  goods?: GoodsItemAdminRecord | null
  reply_list?: GoodsItemMessageRecord[]
}

export interface GoodsItemCommentRecord {
  id: number
  order_id: number
  order_no: string
  goods_id: number
  buyer_user_id: number
  seller_user_id: number
  grade: number
  grade_text?: string
  comment_content: string
  comment_images_json?: string[] | null
  status: string
  status_text?: string
  goods_title?: string
  goods_status?: string
  buyer_name?: string
  buyer_avatar?: string
  pay_price?: string
  order_status?: string
  refund_status?: string
  comment_image_count?: number
  created_at: string | null
  updated_at: string | null
}

export interface GoodsItemCommentTradeRelation {
  id: number
  order_no?: string
  refund_order_no?: string
  payment_order_no?: string
  order_status?: string
  refund_status?: string
  pay_price?: string | number
}

export interface GoodsItemCommentDetail extends GoodsItemCommentRecord {
  goods?: GoodsItemAdminRecord | null
  order?: GoodsItemCommentTradeRelation | null
  payment_order?: GoodsItemCommentTradeRelation | null
  refund_order?: GoodsItemCommentTradeRelation | null
}

export interface PagePayload<T> {
  list: T[]
  total: number
  page: number
  per_page: number
}

function getPage<T>(url: string, params: Record<string, unknown>) {
  return api.get<unknown, { code: number, message: string, data: PagePayload<T> }>(url, { params })
}

function getDetail<T>(url: string, id: number) {
  return api.get<unknown, { code: number, message: string, data: T }>(`${url}/${id}`)
}

function createRecord(url: string, data: Record<string, unknown>) {
  return api.post(url, data)
}

function updateRecord(url: string, id: number, data: Record<string, unknown>) {
  return api.put(`${url}/${id}`, data)
}

function deleteRecord(url: string, id: number) {
  return api.delete(`${url}/${id}`)
}

function batchDeleteRecord(url: string, ids: number[]) {
  return api.delete(`${url}/batch`, {
    data: { ids },
  })
}

function getOptions(url: string, params?: Record<string, unknown>) {
  return api.get<unknown, { code: number, message: string, data: SelectOptionItem[] }>(`${url}/options`, { params })
}

function getSimpleOptions(url: string, params?: Record<string, unknown>) {
  return api.get<unknown, { code: number, message: string, data: SelectOptionItem[] }>(`${url}/simple-options`, { params })
}

const categoryUrl = '/admin/goods/category'
const attributeGroupUrl = '/admin/goods/config/attribute_group'
const optionLibraryUrl = '/admin/goods/config/option_library'
const categoryGroupRelationUrl = '/admin/goods/config/category_group_relation'
const attributeGroupItemUrl = '/admin/goods/config/attribute_group_item'
const serviceFeeRuleUrl = '/admin/goods/config/service_fee_rule'
const goodsItemUrl = '/admin/goods/item'
const goodsMessageUrl = '/admin/goods/item/message'
const goodsCommentUrl = '/admin/goods/item/comment'

export const goodsItemApi = {
  page: (params: Record<string, unknown>) => getPage<GoodsItemAdminRecord>(goodsItemUrl, params),
  detail: (id: number) => getDetail<GoodsItemAdminRecord>(goodsItemUrl, id),
  updateDisplayStatus: (id: number, display_status: 'on_shelf' | 'off_shelf') => api.post(`${goodsItemUrl}/${id}/display-status`, { display_status }),
  audit: (id: number, data: { content_status: 'approved' | 'rejected', audit_remark?: string }) => api.post(`${goodsItemUrl}/${id}/audit`, data),
}

const apiGoodsConfig = {
  category: {
    page: (params: Record<string, unknown>) => getPage<GoodsCategoryItem>(categoryUrl, params),
    tree: (params: Record<string, unknown>) => api.get<unknown, { code: number, message: string, data: PagePayload<GoodsCategoryItem> }>(`${categoryUrl}/tree`, { params }),
    stats: (params: Record<string, unknown>) => api.get<unknown, { code: number, message: string, data: GoodsCategoryStatsPayload }>(`${categoryUrl}/stats`, { params }),
    parentOptions: () => api.get<unknown, { code: number, message: string, data: GoodsCategoryParentOption[] }>(`${categoryUrl}/parent-options`),
    bindOptions: () => api.get<unknown, { code: number, message: string, data: TreeSelectOptionItem[] }>(`${categoryUrl}/bind-options`),
    detail: (id: number) => getDetail<GoodsCategoryItem>(categoryUrl, id),
    create: (data: Record<string, unknown>) => createRecord(categoryUrl, data),
    update: (id: number, data: Record<string, unknown>) => updateRecord(categoryUrl, id, data),
    delete: (id: number) => deleteRecord(categoryUrl, id),
    batchDelete: (ids: number[]) => batchDeleteRecord(categoryUrl, ids),
    options: (params?: Record<string, unknown>) => getOptions(categoryUrl, params),
    simpleOptions: (params?: Record<string, unknown>) => getSimpleOptions(categoryUrl, params),
    sync: () => api.post<unknown, { code: number, message: string, data: GoodsCategorySyncPayload }>(`${categoryUrl}/sync`),
  },
  attributeGroup: {
    page: (params: Record<string, unknown>) => getPage<GoodsAttributeGroupItem>(attributeGroupUrl, params),
    detail: (id: number) => getDetail<GoodsAttributeGroupDetailItem>(attributeGroupUrl, id),
    create: (data: Record<string, unknown>) => createRecord(attributeGroupUrl, data),
    update: (id: number, data: Record<string, unknown>) => updateRecord(attributeGroupUrl, id, data),
    delete: (id: number) => deleteRecord(attributeGroupUrl, id),
    batchDelete: (ids: number[]) => batchDeleteRecord(attributeGroupUrl, ids),
    options: (params?: Record<string, unknown>) => getOptions(attributeGroupUrl, params),
    simpleOptions: (params?: Record<string, unknown>) => getSimpleOptions(attributeGroupUrl, params),
  },
  optionLibrary: {
    page: (params: Record<string, unknown>) => getPage<GoodsOptionLibraryItem>(optionLibraryUrl, params),
    detail: (id: number) => getDetail<GoodsOptionLibraryItem>(optionLibraryUrl, id),
    create: (data: Record<string, unknown>) => createRecord(optionLibraryUrl, data),
    update: (id: number, data: Record<string, unknown>) => updateRecord(optionLibraryUrl, id, data),
    delete: (id: number) => deleteRecord(optionLibraryUrl, id),
    batchDelete: (ids: number[]) => batchDeleteRecord(optionLibraryUrl, ids),
    options: (params?: Record<string, unknown>) => getOptions(optionLibraryUrl, params),
    simpleOptions: (params?: Record<string, unknown>) => getSimpleOptions(optionLibraryUrl, params),
  },
  categoryGroupRelation: {
    page: (params: Record<string, unknown>) => getPage<GoodsCategoryGroupRelationItem>(categoryGroupRelationUrl, params),
    detail: (id: number) => getDetail<GoodsCategoryGroupRelationItem>(categoryGroupRelationUrl, id),
    create: (data: Record<string, unknown>) => createRecord(categoryGroupRelationUrl, data),
    update: (id: number, data: Record<string, unknown>) => updateRecord(categoryGroupRelationUrl, id, data),
    delete: (id: number) => deleteRecord(categoryGroupRelationUrl, id),
    batchDelete: (ids: number[]) => batchDeleteRecord(categoryGroupRelationUrl, ids),
  },
  attributeGroupItem: {
    page: (params: Record<string, unknown>) => getPage<GoodsAttributeGroupOptionItem>(attributeGroupItemUrl, params),
    detail: (id: number) => getDetail<GoodsAttributeGroupOptionItem>(attributeGroupItemUrl, id),
    create: (data: Record<string, unknown>) => createRecord(attributeGroupItemUrl, data),
    update: (id: number, data: Record<string, unknown>) => updateRecord(attributeGroupItemUrl, id, data),
    delete: (id: number) => deleteRecord(attributeGroupItemUrl, id),
    batchDelete: (ids: number[]) => batchDeleteRecord(attributeGroupItemUrl, ids),
  },
  serviceFeeRule: {
    page: (params: Record<string, unknown>) => getPage<GoodsServiceFeeRuleItem>(serviceFeeRuleUrl, params),
    detail: (id: number) => getDetail<GoodsServiceFeeRuleItem>(serviceFeeRuleUrl, id),
    create: (data: Record<string, unknown>) => createRecord(serviceFeeRuleUrl, data),
    update: (id: number, data: Record<string, unknown>) => updateRecord(serviceFeeRuleUrl, id, data),
    delete: (id: number) => deleteRecord(serviceFeeRuleUrl, id),
    batchDelete: (ids: number[]) => batchDeleteRecord(serviceFeeRuleUrl, ids),
    options: (params?: Record<string, unknown>) => getOptions(serviceFeeRuleUrl, params),
    simpleOptions: (params?: Record<string, unknown>) => getSimpleOptions(serviceFeeRuleUrl, params),
  },
  item: goodsItemApi,
  itemMessage: {
    page: (params: Record<string, unknown>) => getPage<GoodsItemMessageRecord>(goodsMessageUrl, params),
    detail: (id: number) => getDetail<GoodsItemMessageDetail>(goodsMessageUrl, id),
    updateStatus: (id: number, status: 'visible' | 'hidden') => api.post(`${goodsMessageUrl}/${id}/status`, { status }),
  },
  itemComment: {
    page: (params: Record<string, unknown>) => getPage<GoodsItemCommentRecord>(goodsCommentUrl, params),
    detail: (id: number) => getDetail<GoodsItemCommentDetail>(goodsCommentUrl, id),
    updateStatus: (id: number, status: 'visible' | 'hidden') => api.post(`${goodsCommentUrl}/${id}/status`, { status }),
  },
}

export default apiGoodsConfig
